import styled from "styled-components";
import { pxToVh } from "../../../utils/calc/pxToVh";

export const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToVh(6)};
  margin-bottom: ${pxToVh(7)};
`;
